<template>
  <div class="main-container">
    <div class="feed-details">
      <div class="feed-details__left">
        <main-menu></main-menu>
      </div>
      <div class="feed-details__right">
        <div class="feed-details-panel">
          <h2 class="main-title">Feed Game details</h2>

          <div class="column-control__wrap">
            <div class="column-control__left column-control__left--feed-details">
              <v-autocomplete
                label="Feed"
                :items="feeds"
                v-model="feed"
                v-on:change="fetchFullFeed(feed)"
                return-object
                >
                <template v-slot:selection="data">{{data.item.name}} ({{data.item.environment}})</template>
                <template v-slot:item="data">
                  <div>
                    <b style="color: #000">{{data.item.name}}</b>
                    <p style="font-size: small; color: #000">{{data.item.environment}}</p>
                  </div>

                </template>
              </v-autocomplete>
              
              <!-- Domains Section -->
              <div v-if="feed" class="domains-section">
                <h3 class="domains-title">Domains</h3>
                <div v-if="domains.length > 0" class="domains-list">
                  <v-chip
                    v-for="domain in domains"
                    :key="domain.id || domain"
                    class="domain-chip"
                    color="primary"
                    variant="outlined"
                    size="small"
                  >
                    {{ domain.name || domain }}
                  </v-chip>
                </div>
                <div v-else class="no-domains">
                  <v-alert
                    type="info"
                    variant="tonal"
                    density="compact"
                    text="No domains found for this feed"
                  ></v-alert>
                </div>
              </div>
              
              <v-autocomplete
                v-if="feed"
                label="Games"
                :items="fullFeed?.feedGames"
                v-model="feedGame"
                return-object
                item-text="game.slug">
              </v-autocomplete>
            </div>
            <div class="column-control__right column-control__right--feed-details">
              <Loader v-if="this.isBusy"></Loader>
              <FeedGameDetails
                v-if="feedGame && !isBusy"
                ref="feedGameDetails"
                :feed="fullFeed"
                :feedGame="feedGame">
              </FeedGameDetails>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Loader from '../../Loader/Loader.vue'
  import InfoModal from '../../InfoModal/InfoModal.vue'
  import FeedsAndGamesList from '../FeedsAndGamesList/FeedsAndGamesList.vue'
  import FeedGameDetails from '../FeedGameDetails/FeedGameDetails.vue'
  import MainMenu from '../../MainMenu/MainMenu.vue'

  export default {
    name: 'FeedsDetailsMain',
    components: {MainMenu, Loader, InfoModal, FeedsAndGamesList, FeedGameDetails},
    data () {
      return {
        isBusy: true,
        feeds: null,
        feed: null,
        fullFeed: null,
        feedGame: null,
        domains: [],
      }
    },
    created: async function () {
      this.isBusy = true;
      this.feeds = await this.$gameApi.get(`/feeds`);
      this.isBusy = false;
    },
    methods: {
      fetchFullFeed: async function (feed) {
        this.isBusy = true;
        try {
          // Fetch feed details and domains in parallel
          const [feedResponse, domainsResponse] = await Promise.all([
            this.$gameApi.get(`/feeds/${feed.id}`),
            this.$gameApi.get(`/domains?feedId=${feed.id}`)
          ]);
          
          this.fullFeed = feedResponse;
          this.domains = domainsResponse || [];
        } catch (error) {
          console.error('Error fetching feed data:', error);
          this.domains = [];
        } finally {
          this.isBusy = false;
        }
      }
    }
  }
</script>

<style scoped src="./FeedsDetailsMain.scss" lang="scss"></style>
